import { iContent, iSection, sectionType } from '@/Engine/apiInterfaces';
import { Wall } from '@/Engine/Wall';
import { Shelf } from '@/Engine/Shelf';
import { $ } from '@/Engine/state';
import { Item } from '@/Engine/Item';
import { Door } from '@/Engine/Door';
import { modelMeta, modelNamesT } from '@/Constants/modelMeta';
import { v3dMesh } from '@/Interfaces/common';
import { changeTextureCustom } from '@/Engine/changeTexture';

const wallLessModels = [
    'ml_01_30_u',
    'ml_01_40_u',
    'ml_02_30',
    'ml_02_40',
    'ml_03_30',
    'ml_03_40',
    'ml_04_30',
    'ml_04_40',
];

export class Section extends Item{
    type: sectionType;
    // number: number;
    // article: string;
    name: modelNamesT;
    doorName: modelNamesT;
    door: Door;
    content: Array<Shelf | Wall> = [];
    width: number;
    nomWidth: number | undefined;
    hasTop = '';
    hasLegs = '';

    constructor(props: iSection, bodyColor: string, doorColor: string, showDoors: boolean) {
        super(props);
        this.type = props.type;
        // this.number = props.number;
        // this.article = props.article;
        this.name = props.blender_name;
        const width = modelMeta[this.name].width;
        this.nomWidth = modelMeta[this.name].nomWidth / 1000;
        if (width) {
            this.width = width/1000;
        } else {
            this.width = 0.3;
        }

        // const basisAoPath = 'AO/' + width + '/Basis/ml_' + width + '_base_AO.jpg';

        this.setColor(bodyColor);
        this.doorName = props.blender_name+'_door' as modelNamesT;
        this.door = new Door(this.doorName, doorColor, this.width, showDoors);
        if (this.name === 'ls_11_50') {
            this.door.model.position.y += 0.043;
        }
        this.model.add(this.door.model);
        // if (showDoors) this.door.close();
        if (wallLessModels.includes(this.name as string)) {
            const shadowWallName = (props.blender_name as string).replace('ml', 'S');
            if ($.app.scene.getObjectByName(shadowWallName as string)) {
                const shadowWall = new Item({ blender_name: shadowWallName });
                console.log(shadowWall._model);
                shadowWall._model.material.opacity = 0.1;
                shadowWall._model.material.transparent = true;
                this.model.add(shadowWall.model);
            } else {
                console.warn('Нет модели с тенью');
            }
        }



        props.content.forEach((item)=>{
            if (item.type === 'shelf') {
                const newShelf = new Shelf(item, bodyColor);
                this.content.push(newShelf);
                this.model.add(newShelf.model);
            } else if (item.type === 'wall') {
                const newWall = new Wall(item, bodyColor, this.width);
                this.content.push(newWall);
                this.model.add(newWall.model);
            }
        });


        const newName = (this.name as string)
            .replace('01', '11')
            .replace('02', '12')
            .replace('03', '13')
            .replace('04', '14')
            .replace('_u', '')
            + '_' + this.door.isOpen + (this.hasLegs || this.hasTop?'_':'') + this.hasLegs + this.hasTop + '_AO.jpg';

        const aoPath = 'AO/' + ((this.nomWidth * 1000) ?? (this.width * 1000)) + '/ml/' + newName;
        console.log('section: ' + aoPath);
        $.textureLoader
            .loadAsync(aoPath)
            .then((texture)=>{
                changeTextureCustom(this._model.material, 'AO', texture);
            })
            .catch((err)=>{
                console.log(aoPath);
                console.error(err);
            });

    }

    destroy() {
        super.destroy();
        this.door.destroy();
    }
}
